import { type Country } from 'src/types/country';
import { type Lang } from 'src/types/lang-locale-type';
import { getTabbyDomain } from 'src/utils/get-tabby-domain';

export const getSubventionFaqLink = (
  lang: Lang,
  country: Country,
  campaignId: string
) => {
  const langCode = lang === 'ar' ? 'ar-AE' : 'en-AE';
  const domain = getTabbyDomain(country);

  return `https://tabby.${domain}/${langCode}/campaigns/${campaignId}`;
};
